<div class="add-org-user-dialog__root">
  <h1 mat-dialog-title class="headline">Add User</h1>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input type="email" matInput inputmode="email" placeholder="e.g., user@clinic.org" formControlName="email" />
        @if (email.invalid && email.touched) {
          <mat-error>{{ getEmailErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Temporary password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          autocomplete="new-password"
          placeholder="Share with the user after creating"
          formControlName="temporaryPassword"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hidePassword ? 'Show temporary password' : 'Hide temporary password'"
          (click)="hidePassword = !hidePassword"
        >
          <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (temporaryPassword.invalid && temporaryPassword.touched) {
          <mat-error>{{ getPasswordErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <div class="temp-password-requirements" aria-label="Password requirements">
        <span class="temp-password-requirements__label">Password requirements:</span>
        <ul class="temp-password-requirements__list">
          @for (item of passwordRequirementItems; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>
      <mat-form-field class="full-width">
        <mat-label>Display name (optional)</mat-label>
        <input type="text" matInput inputmode="text" placeholder="Used for sign-in profile only" formControlName="name" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>DISCARD</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">ADD</button>
  </mat-dialog-actions>
</div>
